import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import FormContainer from "../../components/FormContainer";
import { toast } from "react-toastify";
import { useGetProductDetailsQuery, useUpdateProductMutation, useUploadProductImageMutation } from "../../slices/productsApiSlice";

const ProductEditScreen = () => {
  const {id: productId} = useParams();
  
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState('');
  const [category, setCategory] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [price, setPrice] = useState(100);
  const [bestSeller, setBestSeller] = useState(false);
  const [available, setAvailable] = useState(true);

  const { data: product, isLoading, error, refetch} = useGetProductDetailsQuery(productId);

  const [updateProduct, {isLoading: isLoadingUpdateProduct}] = useUpdateProductMutation();

  const [uploadProductImage, {isLoading: isLoadingUploadProductImage}] = useUploadProductImageMutation();

  const navigate = useNavigate();

  useEffect(() => {
    if (product) {
      setName(product.name);
      setDescription(product.description);
      setImage(product.image);
      setCategory(product.category);
      setSubCategory(product.subCategory);
      setPrice(product.price);
      setBestSeller(product.bestSeller);
      setAvailable(product.available);
    }
  }, [product]);

  const submitHandler = async (e) => {
    e.preventDefault();
    const updatedProduct = {
      _id: productId,
      name,
      description,
      image,
      category,
      subCategory,
      price,
      bestSeller,
      available
    }

    const result = await updateProduct(updatedProduct);

    if (result.error) {
      toast.error(result.error);
    } else {
      toast.success("Product updated");
      navigate("/admin/productlist");
      refetch();
    }
  };

  const uploadFileHandler = async (e) => {
    const formData = new FormData();
    formData.append('image', e.target.files[0]);
    try {
      const res = await uploadProductImage(formData).unwrap();
      toast.success(res.message);
      setImage(res.image);
    } catch (error) {
      toast.error(error?.data?.message||error.error);
    }
  };

  return (
    <>
      <Link to='/admin/productlist' className='btn btn-light my-3'>Back</Link>
      <FormContainer>
        <h1>Edit Product</h1>
        { isLoadingUpdateProduct && <Loader/> }
        { isLoading ? <Loader/> : error ? <Message variant="danger">{error.data.message}</Message> : (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId="name" className="my-2">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="description" className="my-2">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="image" className="my-2">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter image URL"
                value={image}
                onChange={(e) => setImage(e.target.value)}>
              </Form.Control>
              { isLoadingUploadProductImage && <Loader/> }
              <Form.Control
                type="file"
                label="Select file"
                onChange={uploadFileHandler}>                
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="category" className="my-2">
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="subCategory" className="my-2">
              <Form.Label>Sub Category</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter sub category"
                value={subCategory}
                onChange={(e) => setSubCategory(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="price" className="my-2">
              <Form.Label>Price</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}>
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="bestSeller" className="my-2">
              <Form.Label>Best Seller</Form.Label>
              <Form.Check
                type="checkbox"
                id="bestSeller"
                checked={bestSeller ? true : false}
                onChange={(e) => setBestSeller(e.target.checked)}>
              </Form.Check>
            </Form.Group>
            <Form.Group controlId="available" className="my-2">
              <Form.Label>Available</Form.Label>
              <Form.Check
                type="checkbox"
                id="available"
                checked={available ? true : false}
                onChange={(e) => setAvailable(e.target.checked)}>
              </Form.Check>
            </Form.Group>
            <Button type="submit" variant="primary" className="my-2">
              Update
            </Button>
          </Form>
        )}
      </FormContainer>
    </>
  )
}

export default ProductEditScreen